import { MessageConstructor, showSessionMessages } from './message.js';
export let _Vue;

export default {
  install(Vue) {
    _Vue = Vue;
    Vue.prototype.$message = MessageConstructor;
    showSessionMessages();
  }
};
